import { engineComponent } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { UserControls } from "../Common/UserControls/UserControls";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { GameActions } from "../Common/Actions/GameActions";
import { ModuleManager } from "../../Managers/ModuleManager";
import { PickActions } from "../Common/Actions/PickActions";
import { PickController } from "../../GameComponents/Pick/PickController";
import { GameManager } from "../../Managers/GameManager";
import { GameData } from "../Common/Datas/GameData";
import { DataManager } from "../../Managers/DataManager";
import { PickView } from "../../GameComponents/Pick/PickView";

var GameModules = Communication.Game.GameModules;

@engineComponent(ComponentTypes.HtmlElement)
export class MobilePickUserControls extends UserControls {
    protected _controller: PickController;

    private _userControls: HTMLElement;
    private _userControls_supreme: HTMLElement;
    private _baseUserControls: HTMLElement;

    constructor() {
        super("pick");
    }

    create(node: Element): void {
        super.create(node);

        this.registerActions();

        this._userControls = document.getElementById("pickUserControls");
    }

    addController(controller: PickController): void {
        this._controller = controller;
        this._controller.on(PickController.StartReceived, this.startReceived.bind(this));
        this._controller.on(PickController.SelectReceived, this.selectReceived.bind(this));
        this._controller.on(PickController.EndReceived, this.endReceived.bind(this));
        this._controller.on(PickController.SelectComplete, this.selectComplete.bind(this));
        this._controller.on(PickController.IntroFinished, this.introFinished.bind(this));
        this._controller.on(PickController.OutroFinished, this.outroFinished.bind(this));
    }

    registerActions(): void {
        this.actions.registerActions({
            [PickActions.ActionSpot + 0]: false,
            [PickActions.ActionSpot + 1]: false,
            [PickActions.ActionSpot + 2]: false,
            [PickActions.ActionSpot + 3]: false,
            [PickActions.ActionSpot + 4]: false,
            [PickActions.ActionSpot + 5]: false,
            [PickActions.ActionSpot + 6]: false,
            [PickActions.ActionSpot + 7]: false,
            [PickActions.ActionSpot + 8]: false,
            [PickActions.ActionSpot + 9]: false,
            [PickActions.ActionSpot + 10]: false,
            [PickActions.ActionSpot + 11]: false,
            [PickActions.ActionSpot + 12]: false,
            [PickActions.ActionSpot + 13]: false,
            [PickActions.ActionSpot + 14]: false,
        });
    }

    initReceived(): void {
        this._userControls_supreme = document.getElementById("userControls_supreme");

        super.initReceived();

        this._controller.initReceived();

        if (GameManager.pickResponse.multiplier != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinsMultiplier,
                GameManager.pickResponse.multiplier.toString(),
            );
            DataManager.updateDataElement(
                GameData.DataFreeSpinsMultiplier,
                GameManager.pickResponse.multiplier.toString(),
            );
        }

        if (this._userControls != null) {
            this._userControls.style.display = "none";
        }
        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "none";
        }
        if (
            this._userControls_supreme != null &&
            !this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.add(HtmlController.DisabledClass);
        }
    }

    startReceived(): void {
        ModuleManager.outroModule(GameModules.Base);
    }

    selectReceived(): void {
        this.actions.disableAllActions();
    }

    endReceived(): void {
        if (ModuleManager.freespinsEnabled()) {
            ModuleManager.enableFreespins();
        }
    }

    dispatchAction(action: string): void {
        if (ModuleManager.pickEnabled() || ModuleManager.pickActive()) {
            if (action === GameActions.ActionSpinOrStop) {
                return;
            }

            if (this.actions.getActionState(action)) {
                super.dispatchAction(action);

                if (action.substr(0, PickActions.ActionSpot.length) === PickActions.ActionSpot) {
                    let id: number = parseInt(action.substr(PickActions.ActionSpot.length, action.length));
                    this._controller.select(id);
                }
                this.actions.disableAllActions();
            }
            HtmlController.updateActionElements(this.getAllActions());
        }
    }

    start(): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
        this._controller.start();
    }

    back(): void {}

    end(): void {
        if (GameManager.pickResponse.count != null && GameManager.pickResponse.multiplier != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinsCountMultiplier,
                GameManager.pickResponse.count.toString() + ";" + GameManager.pickResponse.multiplier.toString(),
            );
            DataManager.updateDataElement(
                GameData.DataFreeSpinsCountMultiplier,
                GameManager.pickResponse.count.toString() + ";" + GameManager.pickResponse.multiplier.toString(),
            );
        }
        this._controller.end();
    }

    initIntro(): void {
        super.initIntro();
        this._controller.initIntro();
        Platforms.Platforms.featureInit({ type: Communication.Game.GameModules.Pick });
        this.prepareNewGameRound(true);

        if (GameManager.pickResponse.count != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinsRemainingCount,
                GameManager.pickResponse.count.toString(),
            );
            DataManager.updateDataElement(
                GameData.DataFreeSpinsRemainingCount,
                GameManager.pickResponse.count.toString(),
            );
        }

        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }
        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }
        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }

        let canvas = document.getElementById("canvas");
        if (canvas != null) {
            canvas.classList.add("interactive");
        }
    }

    intro(long: boolean = false): void {
        this._controller.intro();

        if (GameManager.pickResponse.count != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinsRemainingCount,
                GameManager.pickResponse.count.toString(),
            );
            DataManager.updateDataElement(
                GameData.DataFreeSpinsRemainingCount,
                GameManager.pickResponse.count.toString(),
            );
        }

        if (GameManager.pickResponse.multiplier != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinsMultiplier,
                GameManager.pickResponse.multiplier.toString(),
            );
            DataManager.updateDataElement(
                GameData.DataFreeSpinsMultiplier,
                GameManager.pickResponse.multiplier.toString(),
            );
        }
    }

    introFinished(): void {
        this.prepareNewGameRound();

        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }
        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }
        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }

        let canvas = document.getElementById("canvas");
        if (canvas != null) {
            canvas.classList.add("interactive");
        }
    }

    outro(): void {
        this._controller.outro();

        setTimeout(() => {
            const baseUserControls = document.getElementById("userControls");

            if (baseUserControls != null) {
                baseUserControls.style.display = "none";
            }
            if (baseUserControls != null && !baseUserControls.classList.contains(HtmlController.DisabledClass)) {
                baseUserControls.classList.add(HtmlController.DisabledClass);
            }

            if (this._userControls != null) {
                this._userControls.style.display = "none";
            }
            if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
                this._userControls.classList.add(HtmlController.DisabledClass);
            }

            if (this._userControls_supreme != null) {
                this._userControls_supreme.style.display = "none";
            }
            if (
                this._userControls_supreme != null &&
                !this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
            ) {
                this._userControls_supreme.classList.add(HtmlController.DisabledClass);
            }

            let canvas = document.getElementById("canvas");
            if (canvas != null) {
                canvas.classList.remove("interactive");
            }
        }, 1000);
    }

    outroFinished(): void {
        ModuleManager.introModule(GameModules.Freespins, true);
    }

    prepareNewGameRound(init: boolean = false): void {
        this.actions.changeActionStates({
            [PickActions.ActionSpot + 0]: false,
            [PickActions.ActionSpot + 1]: false,
            [PickActions.ActionSpot + 2]: false,
            [PickActions.ActionSpot + 3]: false,
            [PickActions.ActionSpot + 4]: false,
            [PickActions.ActionSpot + 5]: false,
            [PickActions.ActionSpot + 6]: false,
            [PickActions.ActionSpot + 7]: false,
            [PickActions.ActionSpot + 8]: false,
            [PickActions.ActionSpot + 9]: false,
            [PickActions.ActionSpot + 10]: false,
            [PickActions.ActionSpot + 11]: false,
            [PickActions.ActionSpot + 12]: false,
            [PickActions.ActionSpot + 13]: false,
            [PickActions.ActionSpot + 14]: false,
        });

        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            if (GameManager.pickResponse.round.remainingPicks === 0) {
                if (!ModuleManager.freespinsEnabled()) {
                    this.end();
                } else {
                    if (GameManager.pickResponse.count != null && GameManager.pickResponse.multiplier != null) {
                        DataManager.updateGameDataFromModule(
                            GameData.DataFreeSpinsCountMultiplier,
                            GameManager.pickResponse.count.toString() +
                                ";" +
                                GameManager.pickResponse.multiplier.toString(),
                        );
                        DataManager.updateDataElement(
                            GameData.DataFreeSpinsCountMultiplier,
                            GameManager.pickResponse.count.toString() +
                                ";" +
                                GameManager.pickResponse.multiplier.toString(),
                        );
                    }
                    ModuleManager.enableFreespins();
                }
                return;
            }

            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();

                if (id != null && status != null && status === "enabled") {
                    this.actions.changeActionState(PickActions.ActionSpot + id, true);
                }
            }
        }

        HtmlController.updateActionElements(this.getAllActions());
    }

    selectComplete(): void {
        this.prepareNewGameRound();
    }

    enable(): void {
        this.start();
    }

    disable(): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Mobile/MobilePickUserControls.ts
 **/